import { Selector } from '../../lib/generated/zeus';
import { relatedNoteSelector } from './note';

export const fatigueReportShiftSelector = Selector('FatigueReportShift')({
  id: true,
  rootId: true,
  startTime: true,
  endTime: true,
  isRecurring: true,
  recurrencePattern: true,
  recurrenceEndDate: true,
  isDerived: true,
  originalShiftId: true,
  isNightShift: true,
  teamRoleName: true,
  team: {
    id: true,
    name: true,
  },
});

export const userShiftSelector = Selector('RosterShift')({
  id: true,
  rootId: true,
  startTime: true,
  endTime: true,
  status: true,
  relatedNotes: relatedNoteSelector,
  isRecurring: true,
  recordStatus: true,
  recurrencePattern: true,
  recurrenceEndDate: true,
  isDerived: true,
  originalShiftId: true,
  teamRoleName: true,
  team: { id: true, name: true },
});

export const fatigueViolationReportSelector = Selector(
  'FatigueViolationReport'
)({
  violated: true,
  shifts: fatigueReportShiftSelector,
});

export const fatigueViolationSelector = Selector('FatigueViolation')({
  dateKey: true,
  report: fatigueViolationReportSelector,
});

export const userFatigueViolationReportSelector = Selector(
  'UserFatigueViolationReport'
)({
  userId: true,
  userShifts: userShiftSelector,
  consecutiveShiftViolations: fatigueViolationSelector,
  maxShiftHoursViolations: fatigueViolationSelector,
  shiftRestGapViolations: fatigueViolationSelector,
});
